module.exports = __webpack_public_path__ + "img/defhead.cc9f47a5.jpeg";